export function showUnsupportedMessage(
  toastFunc: (msg: string) => string | number,
): void {
  toastFunc('데모 페이지에선 지원되지 않습니다.');
}
